export default function ErrorPage() {
	return <section className='flex items-center justify-center w-full h-[100vh]'>임시 에러 페이지</section>;
}
